import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useSelector } from 'react-redux';
import { authReducerSelector } from '../../../store/auth/auth.selectors';
import { accountIdSelector } from '../../../store/account/account.selectors';
import sentryContexts from '../constants/sentryContexts.constant';

const useSentry = () => {
  const authState = useSelector(authReducerSelector);
  const accountId = useSelector(accountIdSelector);

  useEffect(() => {
    if (authState.id) {
      Sentry.setUser({
        id: authState.id,
        role: authState.role,
        permissions: Object.values(authState.permissions)
      });
    }
  }, [authState]);

  useEffect(() => {
    if (accountId) {
      Sentry.setContext(sentryContexts.account, {
        accountId
      });
      Sentry.setTags({ accountId });
    }
  }, [accountId]);
};

export default useSentry;
